var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,_vm._b({tag:"component",attrs:{"target":_vm.to.target || (_vm.$attrs.item && _vm.$attrs.item.target) ? '_blank' : '_self'}},'component',_vm.linkProps(_vm.to),false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }